import BaseModule from "~/vuex/modules/base-module";

let Bookings = {...BaseModule};

Bookings.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/bookings';

    state.lastDate = null;
    state.sort = {};


    return state;
};



export default Bookings;